import HomeOne from "./HomeOne";
import Page404 from "./404";
import Contact from "./Contact";
import Services from './Services';
import ServicePage from './ServicePage';
import BlogList from './BlogList';
import BlogPost from './BlogPost';

/**
 * Faqat haqiqiy sahifalar, ikki tilda.
 *
 *   o'zbekcha  /                /xizmatlar       /xizmatlar/<slug>
 *   ruscha     /ru              /ru/uslugi       /ru/uslugi/<ru-slug>
 *
 * Cybox shablonidan qolgan marshrutlar (home-v2/v3, about-v1/v2, nft-item,
 * road-map-v1/v2, community, coming-soon, blog-details, team-details, /blog)
 * olib tashlandi: ular inglizcha soxta NFT kontenti bo'lib, indekslanib
 * saytning mavzuviy yaxlitligini buzardi. Komponentlari src/pages/ da
 * turibdi — kerak bo'lsa qaytarish oson.
 */
const routes = [
  // ── O'zbekcha ────────────────────────────────────────────────
  { path: '/', component: <HomeOne />},
  { path: '/xizmatlar', component: <Services />},
  { path: '/xizmatlar/:slug', component: <ServicePage />},
  { path: '/blog', component: <BlogList />},
  { path: '/blog/:slug', component: <BlogPost />},
  // Alohida sahifa sifatida — sarlavha h1 bo'ladi (bosh sahifada h2)
  { path: '/contact', component: <Contact as="h1" />},

  // ── Ruscha ───────────────────────────────────────────────────
  { path: '/ru', component: <HomeOne />},
  { path: '/ru/uslugi', component: <Services />},
  { path: '/ru/uslugi/:slug', component: <ServicePage />},
  { path: '/ru/blog', component: <BlogList />},
  { path: '/ru/blog/:slug', component: <BlogPost />},
  { path: '/ru/contact', component: <Contact as="h1" />},

  { path: '/404', component: <Page404 />},
]

export default routes;
